// extracted by mini-css-extract-plugin
export var equalColumn = "_j5-0";